import {
  addGroupMembers as publicAddGroupMembers,
  removeGroupMembers as publicRemoveGroupMembers,
  listGroupMembers as publicListGroupMembers,
  queryGroupMembers as publicQueryGroupMembers,
  typedQueryGroupMembers as publicTypedQueryGroupMembers,
  listMemberships as publicListMemberships,
  queryMemberships as publicQueryMemberships,
} from './social-groups-v2-group-member-members.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onGroupMemberAdded as publicOnGroupMemberAdded } from './social-groups-v2-group-member-members.public.js';
import { onGroupMemberRemoved as publicOnGroupMemberRemoved } from './social-groups-v2-group-member-members.public.js';

export const addGroupMembers: MaybeContext<
  BuildRESTFunction<typeof publicAddGroupMembers> & typeof publicAddGroupMembers
> = /*#__PURE__*/ createRESTModule(publicAddGroupMembers);
export const removeGroupMembers: MaybeContext<
  BuildRESTFunction<typeof publicRemoveGroupMembers> &
    typeof publicRemoveGroupMembers
> = /*#__PURE__*/ createRESTModule(publicRemoveGroupMembers);
export const listGroupMembers: MaybeContext<
  BuildRESTFunction<typeof publicListGroupMembers> &
    typeof publicListGroupMembers
> = /*#__PURE__*/ createRESTModule(publicListGroupMembers);
export const queryGroupMembers: MaybeContext<
  BuildRESTFunction<typeof publicQueryGroupMembers> &
    typeof publicQueryGroupMembers
> = /*#__PURE__*/ createRESTModule(publicQueryGroupMembers);
export const typedQueryGroupMembers: MaybeContext<
  BuildRESTFunction<typeof publicTypedQueryGroupMembers> &
    typeof publicTypedQueryGroupMembers
> = /*#__PURE__*/ createRESTModule(publicTypedQueryGroupMembers);
export const listMemberships: MaybeContext<
  BuildRESTFunction<typeof publicListMemberships> & typeof publicListMemberships
> = /*#__PURE__*/ createRESTModule(publicListMemberships);
export const queryMemberships: MaybeContext<
  BuildRESTFunction<typeof publicQueryMemberships> &
    typeof publicQueryMemberships
> = /*#__PURE__*/ createRESTModule(publicQueryMemberships);
/**
 * Triggered when a new member is added to a group, either directly by an admin or when a Join Request is approved.
 */
export const onGroupMemberAdded: BuildEventDefinition<
  typeof publicOnGroupMemberAdded
> &
  typeof publicOnGroupMemberAdded = createEventModule(publicOnGroupMemberAdded);
/**
 * Triggered when a member is removed from a group.
 */
export const onGroupMemberRemoved: BuildEventDefinition<
  typeof publicOnGroupMemberRemoved
> &
  typeof publicOnGroupMemberRemoved = createEventModule(
  publicOnGroupMemberRemoved
);

export {
  Role,
  JoinBy,
  SortOrder,
  MembershipStatus,
  WebhookIdentityType,
} from './social-groups-v2-group-member-members.universal.js';
export {
  GroupMember,
  GroupRole,
  SocialGroupsEvent,
  SocialGroupsEventPayloadOneOf,
  MemberJoinedGroup,
  MembersAddedToGroup,
  JoinRequestsApproved,
  MembersInvitedToGroup,
  JoinRequest,
  MembershipQuestionAnswer,
  JoinResponse,
  MemberJoined,
  LeaveRequest,
  LeaveResponse,
  MemberLeft,
  AddGroupMembersRequest,
  AddGroupMembersResponse,
  MemberAdded,
  RemoveGroupMembersRequest,
  RemoveGroupMembersResponse,
  MemberRemoved,
  ListGroupMembersRequest,
  ListGroupMembersResponse,
  PagingMetadata,
  QueryGroupMembersRequest,
  Query,
  Sorting,
  Paging,
  QueryGroupMembersResponse,
  QueryNonGroupMembersRequest,
  QueryNonGroupMembersResponse,
  ListMembershipsRequest,
  ListMembershipsResponse,
  Membership,
  QueryMembershipsRequest,
  QueryMembershipsResponse,
  QueryMyMembershipRequest,
  QueryMyMembershipResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  GroupMemberAddedEnvelope,
  GroupMemberRemovedEnvelope,
  ListGroupMembersOptions,
  MembersQueryResult,
  MembersQueryBuilder,
  GroupMemberQuerySpec,
  ListMembershipsOptions,
  QueryMembershipsOptions,
} from './social-groups-v2-group-member-members.universal.js';
export { utils } from './social-groups-v2-group-member-members.universal.js';
export {
  RoleWithLiterals,
  JoinByWithLiterals,
  SortOrderWithLiterals,
  MembershipStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  GroupMemberQuery,
} from './social-groups-v2-group-member-members.universal.js';
